import { combineReducers } from "redux";
import {
  GET_DEALER_REGION_DT,
  GET_DEALER_REGION_DT_OK,
  GET_DEALER_REGION_DT_ERR,
  DO_DEALER_REGION_DT_CLEANUP,
  APPLY_DEALER_REGION_DT_FILTERS,
  CLEAR_DEALER_REGION_DT_FILTERS,

  GET_DEALER_GROUP_REGION_LIST,
  GET_DEALER_REGION_LIST_OK,
  GET_DEALER_REGION_LIST_ERR,
  DO_DEALER_REGION_LIST_CLEANUP,
} from "./actionTypes";

/********** DATATABLE **********/

const defaultDtState = {
  dealerRegions: [],
  dealerRegionsError: null,
  totalCount: 0,
  listParams: {
    sortBy: 'id',
    sortDir: 'desc',
    pageSize: 50,
    page: 1,
    search: null,
    filters: null,
  },
  isLoadInProgress: false,
};

const Dt = (state = defaultDtState, action) => {
  switch (action.type) {
    case GET_DEALER_REGION_DT:
      state = {
        ...state,
        listParams: action.payload.params,
        dealerRegionsError: null,
        isLoadInProgress: true,
      };
      break
    case GET_DEALER_REGION_DT_OK:
      state = {
        ...state,
        dealerRegions: action.payload.response.dealerRegions,
        totalCount: action.payload.response.totalCount,
        isLoadInProgress: false,
      };
      break
    case GET_DEALER_REGION_DT_ERR:
      state = {
        ...state,
        dealerRegions: [],
        totalCount: 0,
        dealerRegionsError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    case DO_DEALER_REGION_DT_CLEANUP:
      state = {
        ...state,
        dealerRegions: [],
        dealerRegionsError: null,
      };
      break
  }
  return state;
}

/********** DATATABLE FILTERS **********/

const defaultDtFiltersState = {
  name: '',
};

const DtFilters = (state = defaultDtFiltersState, action) => {
  switch (action.type) {
    case APPLY_DEALER_REGION_DT_FILTERS:
      state = action.payload.filters;
      break
    case CLEAR_DEALER_REGION_DT_FILTERS:
      state = { ...defaultDtFiltersState };
      break
  }
  return state;
}

/********* LIST *********/

const defaultListState = {
  regions: [],
  regionsError: null,
  isLoadInProgress: false,
};

const List = (state = defaultListState, action) => {
  switch (action.type) {
    case GET_DEALER_GROUP_REGION_LIST:
      state = {
        ...state,
        regionsError: null,
        isLoadInProgress: true,
      };
      break
    case GET_DEALER_REGION_LIST_OK:
      state = {
        ...state,
        regions: action.payload.response.dealerRegions,
        isLoadInProgress: false,
      };
      break
    case GET_DEALER_REGION_LIST_ERR:
      state = {
        ...state,
        regions: [],
        regionsError: action.payload.error,
        isLoadInProgress: false,
      };
      break
    case DO_DEALER_REGION_LIST_CLEANUP:
      state = { ...defaultListState };
      break
  }
  return state;
}

export default combineReducers({
  Dt,
  DtFilters,
  List,
})